import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import CompletedOrderView from '../features/order-view/CompletedOrderView'
import InProgressOrderView from '../features/order-view/InProgressOrderView'
import Diagnostic from '../features/diagnostic/Diagnostic'
import ClientEditModal from '../features/client-edit/ClientEditModal'
import OrderModal from '../features/order-create/OrderModal'
import { useOrderUpdates } from '../shared/lib/useOrderUpdates'

export default function OrderPage() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { user, token } = useAuth()
    const [order, setOrder] = useState(null)
    const [loading, setLoading] = useState(true)
    const [showClientEdit, setShowClientEdit] = useState(false)
    const revision = useOrderUpdates(user.role === 'mechanic' ? null : id, token)

    useEffect(() => {
        if (!id || !token) return
        const controller = new AbortController()
        fetch(`/api/orders/${id}`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal })
            .then(res => res.json())
            .then(data => {
                if (data && data.id) setOrder(data)
                else navigate('/', { replace: true })
            })
            .catch(error => { if (error.name !== 'AbortError') console.error('Не удалось обновить заявку', error) })
            .finally(() => { if (!controller.signal.aborted) setLoading(false) })
        return () => controller.abort()
    }, [id, token, revision, navigate])

    const onBack = () => navigate('/')

    if (loading) return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F2F4F7' }}>
            <p style={{ color: '#9CA3AF', fontSize: '13px' }}>Загрузка...</p>
        </div>
    )

    if (!order) return null

    const editModal = showClientEdit
        ? order.status === 'open'
            ? <OrderModal order={order} token={token} onClose={() => setShowClientEdit(false)} onSave={(updatedOrder) => setOrder(prev => ({ ...prev, ...updatedOrder }))} />
            : <ClientEditModal order={order} token={token} onClose={() => setShowClientEdit(false)} onSave={(updatedOrder) => setOrder(prev => ({ ...prev, ...updatedOrder }))} />
        : null

    const isCompleted = order.status === 'closed' || order.outcome === 'approved' || order.is_sent

    // Механик
    if (user.role === 'mechanic') {
        if (isCompleted) return <CompletedOrderView order={order} token={token} showBack={true} onBack={onBack} />
        return <Diagnostic order={order} onBack={onBack} onComplete={(completedOrder) => setOrder(completedOrder)} />
    }

    // Все остальные роли (master, ros, master_workshop, admin)
    if (isCompleted) return <CompletedOrderView order={order} token={token} showBack={true} onBack={onBack} />
    return (
        <>
            <InProgressOrderView order={order} token={token} refreshKey={revision} showBack={true} onBack={onBack} canEdit={user.role === 'master'} onEditClient={() => setShowClientEdit(true)} />
            {editModal}
        </>
    )
}
